/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';

export const DropDownList = React.forwardRef(
  ({ options, id, showLabel, label, subtitle, onChange, onBlur, ...props }, ref) => {
    const elmentId = id || 'dllId';

    let correctedClassname = props.className || '';
    const disabled = props.disabled || false;

    if (disabled) {
      correctedClassname += ' bg-gray-100';
    }

    return (
      <div>
        {showLabel && (
          <label htmlFor={elmentId} className="block text-sm font-medium text-gray-700">
            {label || ''}
          </label>
        )}
        {!!subtitle && (
        <p className="text-xs mt-1 mb-2 text-gray-500">
          {subtitle}
        </p>
        )}
        {options && options.length > 0 && (
          <select
            ref={ref}
            onBlur={onBlur}
            onChange={onChange}
            defaultValue={props.defaultValue}
            // value={selectedValue || defaultValue || undefined}
            {...props}
            className={correctedClassname}
          >
            {options?.map((item) => (
              <option key={`ddl_item_${item.key || item.value}`} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        )}
      </div>
    );
  },
);
